import { InjectionToken } from '@angular/core';
import { RelationRequestTables } from './grid-table-factory/table-creator.enum';
import { RelationPageTabs } from './relation-request.enum';
import {
  ConnectionRequest,
  DoctorLink,
  FilterValue,
  PatientLink,
  RelationRequestsPageConfig,
} from './relation-request.interface';
import { UserRelationRequestService } from './services/relation-request.service';

export type RelationRequestsTables = Record<RelationPageTabs, RelationRequestTables>;

export const DOCTOR_LINK_SERVICE_TOKEN: InjectionToken<UserRelationRequestService<DoctorLink>> = new InjectionToken<
  UserRelationRequestService<DoctorLink>
>('DOCTOR_LINK_SERVICE_TOKEN');

export const PATIENT_LINK_SERVICE_TOKEN: InjectionToken<UserRelationRequestService<PatientLink>> = new InjectionToken<
  UserRelationRequestService<PatientLink>
>('PATIENT_LINK_SERVICE_TOKEN');

export const CONNECTION_SERVICE_TOKEN: InjectionToken<UserRelationRequestService<ConnectionRequest>> =
  new InjectionToken<UserRelationRequestService<ConnectionRequest>>('CONNECTION_SERVICE_TOKEN');

export const RELATION_REQUESTS_TABLES: InjectionToken<RelationRequestsTables> =
  new InjectionToken<RelationRequestsTables>('RELATION_REQUESTS_TABLES_TOKEN');

export const RELATION_REQUESTS_PAGE_CONFIG: InjectionToken<RelationRequestsPageConfig<FilterValue>> =
  new InjectionToken<RelationRequestsPageConfig<FilterValue>>('RELATION_REQUESTS_PAGE_CONFIG');
